var map = {
	"./excel.png": "FVKf",
	"./ic_logo_jns_login.png": "S3Yl",
	"./ic_logo_jns_menu.png": "nJAj",
	"./logo_jns.png": "wSBx",
	"./logo_login_jns.png": "nONT",
	"./logo_login_jns_white.png": "u00v",
	"./novas_demandas.png": "dYGt",
	"./pdf.png": "vOIX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BEjn";


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.png$
// module id = BEjn
// module chunks = 0